import React from 'react';
import './CallToAction.scss';
import { SmartLink } from '../SmartLink/SmartLink';

export type CallToActionBgColors = `gray` | `blue`;

export interface CallToActionInputs {
    color: CallToActionBgColors;
    title: string;
    content: string;
    url: string;
    buttonText: string;
}

export const CallToAction = ({ inputs }: { inputs: CallToActionInputs }) => {
    return (
        <section className="paragraph__call_to_action">
            <h2 className="typestack-title-3">{inputs.title}</h2>
            <div
                className="text"
                dangerouslySetInnerHTML={{ __html: inputs.content }}
            ></div>
            {!!inputs.url && (
                <SmartLink url={inputs.url} button={true}>
                    {inputs.buttonText}
                </SmartLink>
            )}
        </section>
    );
};
